module.exports = __webpack_public_path__ + "aw.svg?2c7ed62ea28f78e4ef20bcb229fa0766";